import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getProfileDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  userProfileSettings: [
    {
      fieldName: "Title",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title",
      placeholder: "Enter Title",
      validation: { required: "Title is required" },
    },
    {
      fieldName: "Language Image",
      fieldValue: "field_language_image",
      className: "col-span-6",
      type: "image",
      name: "field_language_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Language Image",
      placeholder: "Enter Language Image",
      validation: { required: "Language Image is required" },
    },
    {
      fieldName: "Camera (EN)",
      fieldValue: "field_camera_en",
      className: "col-span-6",
      type: "text",
      name: "field_camera_en",
      formType: "input",
      label: "Camera (EN)",
      placeholder: "Enter Camera (EN)",
      validation: { required: "Camera (EN) is required" },
    },
    {
      fieldName: "Camera (MS)",
      fieldValue: "field_camera_ms",
      className: "col-span-6",
      type: "text",
      name: "field_camera_ms",
      formType: "input",
      label: "Camera (MS)",
      placeholder: "Enter Camera (MS)",
      // validation: { required: "Camera (MS) is required" },
    },
    {
      fieldName: "Camera (ZH)",
      fieldValue: "field_camera_zh",
      className: "col-span-6",
      type: "text",
      name: "field_camera_zh",
      formType: "input",
      label: "Camera (ZH)",
      placeholder: "Enter Camera (ZH)",
      // validation: { required: "Camera (ZH) is required" },
    },
    {
      fieldName: "Change Password (EN)",
      fieldValue: "field_change_pwd_en",
      className: "col-span-6",
      type: "text",
      name: "field_change_pwd_en",
      formType: "input",
      label: "Change Password (EN)",
      placeholder: "Enter Change Password (EN)",
      validation: { required: "Change Password (EN) is required" },
    },
    {
      fieldName: "Change Password (MS)",
      fieldValue: "field_change_pwd_ms",
      className: "col-span-6",
      type: "text",
      name: "field_change_pwd_ms",
      formType: "input",
      label: "Change Password (MS)",
      placeholder: "Enter Change Password (MS)",
      // validation: { required: "Change Password (MS) is required" },
    },
    {
      fieldName: "Change Password (ZH)",
      fieldValue: "field_change_pwd_zh",
      className: "col-span-6",
      type: "text",
      name: "field_change_pwd_zh",
      formType: "input",
      label: "Change Password (ZH)",
      placeholder: "Enter Change Password (ZH)",
      // validation: { required: "Change Password (ZH) is required" },
    },
    {
      fieldName: "Favourite Text (EN)",
      fieldValue: "field_favourite_text",
      className: "col-span-6",
      type: "text",
      name: "field_favourite_text",
      formType: "input",
      label: "Favourite Text (EN)",
      placeholder: "Enter Favourite Text (EN)",
      validation: { required: "Favourite Text (EN) is required" },
    },
    {
      fieldName: "Favourite Text (MS)",
      fieldValue: "field_favourite_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_favourite_text_ms",
      formType: "input",
      label: "Favourite Text (MS)",
      placeholder: "Enter Favourite Text (MS)",
      // validation: { required: "Favourite Text (MS) is required" },
    },
    {
      fieldName: "Favourite Text (ZH)",
      fieldValue: "field_favourite_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_favourite_text_zh",
      formType: "input",
      label: "Favourite Text (ZH)",
      placeholder: "Enter Favourite Text (ZH)",
      // validation: { required: "Favourite Text (ZH) is required" },
    },
    {
      fieldName: "Generated (EN)",
      fieldValue: "field_generated_en",
      className: "col-span-6",
      type: "text",
      name: "field_generated_en",
      formType: "input",
      label: "Generated (EN)",
      placeholder: "Enter Generated (EN)",
      validation: { required: "Generated (EN) is required" },
    },
    {
      fieldName: "Generated (MS)",
      fieldValue: "field_generated_ms",
      className: "col-span-6",
      type: "text",
      name: "field_generated_ms",
      formType: "input",
      label: "Generated (MS)",
      placeholder: "Enter Generated (MS)",
      // validation: { required: "Generated (MS) is required" },
    },
    {
      fieldName: "Generated (ZH)",
      fieldValue: "field_generated_zh",
      className: "col-span-6",
      type: "text",
      name: "field_generated_zh",
      formType: "input",
      label: "Generated (ZH)",
      placeholder: "Enter Generated (ZH)",
      // validation: { required: "Generated (ZH) is required" },
    },
    {
      fieldName: "Location (EN)",
      fieldValue: "field_location_en",
      className: "col-span-6",
      type: "text",
      name: "field_location_en",
      formType: "input",
      label: "Location (EN)",
      placeholder: "Enter Location (EN)",
      validation: { required: "Location (EN) is required" },
    },
    {
      fieldName: "Location (MS)",
      fieldValue: "field_location_ms",
      className: "col-span-6",
      type: "text",
      name: "field_location_ms",
      formType: "input",
      label: "Location (MS)",
      placeholder: "Enter Location (MS)",
      // validation: { required: "Location (MS) is required" },
    },
    {
      fieldName: "Location (ZH)",
      fieldValue: "field_location_zh",
      className: "col-span-6",
      type: "text",
      name: "field_location_zh",
      formType: "input",
      label: "Location (ZH)",
      placeholder: "Enter Location (ZH)",
      // validation: { required: "Location (ZH) is required" },
    },
    {
      fieldName: "Login Id Text (EN)",
      fieldValue: "field_login_id_text_en",
      className: "col-span-6",
      type: "text",
      name: "field_login_id_text_en",
      formType: "input",
      label: "Login Id Text (EN)",
      placeholder: "Enter Login Id Text (EN)",
      validation: { required: "Login Id Text (EN) is required" },
    },
    {
      fieldName: "Login Id Text (MS)",
      fieldValue: "field_login_id_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_login_id_text_ms",
      formType: "input",
      label: "Login Id Text (MS)",
      placeholder: "Enter Login Id Text (MS)",
      // validation: { required: "Login Id Text (MS) is required" },
    },
    {
      fieldName: "Login Id Text (ZH)",
      fieldValue: "field_login_id_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_login_id_text_zh",
      formType: "input",
      label: "Login Id Text (ZH)",
      placeholder: "Enter Login Id Text (ZH)",
      // validation: { required: "Login Id Text (ZH) is required" },
    },
    {
      fieldName: "Field Logout (EN)",
      fieldValue: "field_logout_en",
      className: "col-span-6",
      type: "text",
      name: "field_logout_en",
      formType: "input",
      label: "Field Logout (EN)",
      placeholder: "Enter Field Logout (EN)",
      validation: { required: "Field Logout (EN) is required" },
    },
    {
      fieldName: "Field Logout (MS)",
      fieldValue: "field_logout_ms",
      className: "col-span-6",
      type: "text",
      name: "field_logout_ms",
      formType: "input",
      label: "Field Logout (MS)",
      placeholder: "Enter Field Logout (MS)",
      // validation: { required: "Field Logout (MS) is required" },
    },
    {
      fieldName: "Field Logout (ZH)",
      fieldValue: "field_logout_zh",
      className: "col-span-6",
      type: "text",
      name: "field_logout_zh",
      formType: "input",
      label: "Field Logout (ZH)",
      placeholder: "Enter Field Logout (ZH)",
      // validation: { required: "Field Logout (ZH) is required" },
    },
    {
      fieldName: "Notification (EN)",
      fieldValue: "field_notifications_en",
      className: "col-span-6",
      type: "text",
      name: "field_notifications_en",
      formType: "input",
      label: "Notification (EN)",
      placeholder: "Enter Notifications (EN)",
      validation: { required: "Notifications (EN) is required" },
    },
    {
      fieldName: "Notification (MS)",
      fieldValue: "field_notification_ms",
      className: "col-span-6",
      type: "text",
      name: "field_notification_ms",
      formType: "input",
      label: "Notification (MS)",
      placeholder: "Enter Notification (MS)",
      // validation: { required: "Notification (MS) is required" },
    },
    {
      fieldName: "Notification (ZH)",
      fieldValue: "field_notifications_zh",
      className: "col-span-6",
      type: "text",
      name: "field_notifications_zh",
      formType: "input",
      label: "Notification (ZH)",
      placeholder: "Enter Notification (ZH)",
      // validation: { required: "Notification (ZH) is required" },
    },
    {
      fieldName: "Permission (EN)",
      fieldValue: "field_permission_en",
      className: "col-span-6",
      type: "text",
      name: "field_permission_en",
      formType: "input",
      label: "Permission (EN)",
      placeholder: "Enter Permission (EN)",
      validation: { required: "Permission (EN) is required" },
    },
    {
      fieldName: "Permission (MS)",
      fieldValue: "field_permission_ms",
      className: "col-span-6",
      type: "text",
      name: "field_permission_ms",
      formType: "input",
      label: "Permission (MS)",
      placeholder: "Enter Permission (MS)",
      // validation: { required: "Permission (MS) is required" },
    },
    {
      fieldName: "Permission (ZH)",
      fieldValue: "field_permission_zh",
      className: "col-span-6",
      type: "text",
      name: "field_permission_zh",
      formType: "input",
      label: "Permission (ZH)",
      placeholder: "Enter Permission (ZH)",
      // validation: { required: "Permission (ZH) is required" },
    },
    {
      fieldName: "Progress (EN)",
      fieldValue: "field_progress_en",
      className: "col-span-6",
      type: "text",
      name: "field_progress_en",
      formType: "input",
      label: "Progress (EN)",
      placeholder: "Enter Progress (EN)",
      validation: { required: "Progress (EN) is required" },
    },
    {
      fieldName: "Progress (MS)",
      fieldValue: "field_progress_ms",
      className: "col-span-6",
      type: "text",
      name: "field_progress_ms",
      formType: "input",
      label: "Progress (MS)",
      placeholder: "Enter Progress (MS)",
      // validation: { required: "Progress (MS) is required" },
    },
    {
      fieldName: "Progress (ZH)",
      fieldValue: "field_progress_zh",
      className: "col-span-6",
      type: "text",
      name: "field_progress_zh",
      formType: "input",
      label: "Progress (ZH)",
      placeholder: "Enter Progress (ZH)",
      // validation: { required: "Progress (ZH) is required" },
    },
    {
      fieldName: "Purchase (EN)",
      fieldValue: "field_purchase_en",
      className: "col-span-6",
      type: "text",
      name: "field_purchase_en",
      formType: "input",
      label: "Purchase (EN)",
      placeholder: "Enter Purchase (EN)",
      validation: { required: "Purchase (EN) is required" },
    },
    {
      fieldName: "Purchase (MS)",
      fieldValue: "field_purchase_ms",
      className: "col-span-6",
      type: "text",
      name: "field_purchase_ms",
      formType: "input",
      label: "Purchase (MS)",
      placeholder: "Enter Purchase (MS)",
      // validation: { required: "Purchase (MS) is required" },
    },
    {
      fieldName: "Purchase (ZH)",
      fieldValue: "field_purchase_zh",
      className: "col-span-6",
      type: "text",
      name: "field_purchase_zh",
      formType: "input",
      label: "Purchase (ZH)",
      placeholder: "Enter Purchase (ZH)",
      // validation: { required: "Purchase (ZH) is required" },
    },
    {
      fieldName: "Purchase Login (EN)",
      fieldValue: "field_purchase_login_en",
      className: "col-span-6",
      type: "text",
      name: "field_purchase_login_en",
      formType: "input",
      label: "Purchase Login (EN)",
      placeholder: "Enter Purchase Login (EN)",
      validation: { required: "Purchase Login (EN) is required" },
    },
    {
      fieldName: "Purchase Login (MS)",
      fieldValue: "field_purchase_login_ms",
      className: "col-span-6",
      type: "text",
      name: "field_purchase_login_ms",
      formType: "input",
      label: "Purchase Login (MS)",
      placeholder: "Enter Purchase Login (MS)",
      // validation: { required: "Purchase Login (MS) is required" },
    },
    {
      fieldName: "Purchase Login (ZH)",
      fieldValue: "field_purchase_login_zh",
      className: "col-span-6",
      type: "text",
      name: "field_purchase_login_zh",
      formType: "input",
      label: "Purchase Login (ZH)",
      placeholder: "Enter Purchase Login (ZH)",
      // validation: { required: "Purchase Login (ZH) is required" },
    },
    {
      fieldName: "Settings (EN)",
      fieldValue: "field_settings_en",
      className: "col-span-6",
      type: "text",
      name: "field_settings_en",
      formType: "input",
      label: "Settings (EN)",
      placeholder: "Enter Settings (EN)",
      validation: { required: "Settings (EN) is required" },
    },
    {
      fieldName: "Settings (MS)",
      fieldValue: "field_settings_ms",
      className: "col-span-6",
      type: "text",
      name: "field_settings_ms",
      formType: "input",
      label: "Settings (MS)",
      placeholder: "Enter Settings (MS)",
      // validation: { required: "Settings (MS) is required" },
    },
    {
      fieldName: "Settings (ZH)",
      fieldValue: "field_settings_zh",
      className: "col-span-6",
      type: "text",
      name: "field_settings_zh",
      formType: "input",
      label: "Settings (ZH)",
      placeholder: "Enter Settings (ZH)",
      // validation: { required: "Settings (ZH) is required" },
    },
    {
      fieldName: "Updates (EN)",
      fieldValue: "field_updates_en",
      className: "col-span-6",
      type: "text",
      name: "field_updates_en",
      formType: "input",
      label: "Updates (EN)",
      placeholder: "Enter Updates (EN)",
      validation: { required: "Updates (EN) is required" },
    },
    {
      fieldName: "Updates (MS)",
      fieldValue: "field_updates_ms",
      className: "col-span-6",
      type: "text",
      name: "field_updates_ms",
      formType: "input",
      label: "Updates (MS)",
      placeholder: "Enter Updates (MS)",
      // validation: { required: "Updates (MS) is required" },
    },
    {
      fieldName: "Updates (ZH)",
      fieldValue: "field_updates_zh",
      className: "col-span-6",
      type: "text",
      name: "field_updates_zh",
      formType: "input",
      label: "Updates (ZH)",
      placeholder: "Enter Updates (ZH)",
      // validation: { required: "Updates (ZH) is required" },
    },
    {
      fieldName: "User Profile (EN)",
      fieldValue: "field_user_profile_en",
      className: "col-span-6",
      type: "text",
      name: "field_user_profile_en",
      formType: "input",
      label: "User Profile (EN)",
      placeholder: "Enter User Profile (EN)",
      validation: { required: "User Profile (EN) is required" },
    },
    {
      fieldName: "User Profile (MS)",
      fieldValue: "field_user_profile_ms",
      className: "col-span-6",
      type: "text",
      name: "field_user_profile_ms",
      formType: "input",
      label: "User Profile (MS)",
      placeholder: "Enter User Profile (MS)",
      // validation: { required: "User Profile (MS) is required" },
    },
    {
      fieldName: "User Profile (ZH)",
      fieldValue: "field_user_profile_zh",
      className: "col-span-6",
      type: "text",
      name: "field_user_profile_zh",
      formType: "input",
      label: "User Profile (ZH)",
      placeholder: "Enter User Profile (ZH)",
      // validation: { required: "User Profile (ZH) is required" },
    },
    {
      fieldName: "Version (EN)",
      fieldValue: "field_version_en",
      className: "col-span-6",
      type: "text",
      name: "field_version_en",
      formType: "input",
      label: "Version (EN)",
      placeholder: "Enter Version (EN)",
      validation: { required: "Version (EN) is required" },
    },
    {
      fieldName: "Version (MS)",
      fieldValue: "field_version_ms",
      className: "col-span-6",
      type: "text",
      name: "field_version_ms",
      formType: "input",
      label: "Version (MS)",
      placeholder: "Enter Version (MS)",
      // validation: { required: "Version (MS) is required" },
    },
    {
      fieldName: "Version (ZH)",
      fieldValue: "field_version_zh",
      className: "col-span-6",
      type: "text",
      name: "field_version_zh",
      formType: "input",
      label: "Version (ZH)",
      placeholder: "Enter Version (ZH)",
      // validation: { required: "Version (ZH) is required" },
    },
    {
      fieldName: "Profile (EN)",
      fieldValue: "field_profile_en",
      className: "col-span-6",
      type: "text",
      name: "field_profile_en",
      formType: "input",
      label: "Profile (EN)",
      placeholder: "Enter Profile (EN)",
      validation: { required: "Profile (EN) is required" },
    },
    {
      fieldName: "Profile (MS)",
      fieldValue: "field_profile_ms",
      className: "col-span-6",
      type: "text",
      name: "field_profile_ms",
      formType: "input",
      label: "Profile (MS)",
      placeholder: "Enter Profile (MS)",
      // validation: { required: "Profile (MS) is required" },
    },
    {
      fieldName: "Profile (ZH)",
      fieldValue: "field_profile_zh",
      className: "col-span-6",
      type: "text",
      name: "field_profile_zh",
      formType: "input",
      label: "Profile (ZH)",
      placeholder: "Enter Profile (ZH)",
      // validation: { required: "Profile (ZH) is required" },
    },
    {
      fieldName: "Edit Profile (EN)",
      fieldValue: "field_edit_profile_en",
      className: "col-span-6",
      type: "text",
      name: "field_edit_profile_en",
      formType: "input",
      label: "Edit Profile (EN)",
      placeholder: "Enter Edit Profile (EN)",
      validation: { required: "Edit Profile (EN) is required" },
    },
    {
      fieldName: "Edit Profile (MS)",
      fieldValue: "field_edit_profile_ms",
      className: "col-span-6",
      type: "text",
      name: "field_edit_profile_ms",
      formType: "input",
      label: "Edit Profile (MS)",
      placeholder: "Enter Edit Profile (MS)",
      // validation: { required: "Edit Profile (MS) is required" },
    },
    {
      fieldName: "Edit Profile (ZH)",
      fieldValue: "field_edit_profile_zh",
      className: "col-span-6",
      type: "text",
      name: "field_edit_profile_zh",
      formType: "input",
      label: "Edit Profile (ZH)",
      placeholder: "Enter Edit Profile (ZH)",
      // validation: { required: "Edit Profile (ZH) is required" },
    },
    {
      fieldName: "View ID (EN)",
      fieldValue: "field_view_id_en",
      className: "col-span-6",
      type: "text",
      name: "field_view_id_en",
      formType: "input",
      label: "View ID (EN)",
      placeholder: "Enter View ID (EN)",
      validation: { required: "View ID (EN) is required" },
    },
    {
      fieldName: "View ID (MS)",
      fieldValue: "field_view_id_ms",
      className: "col-span-6",
      type: "text",
      name: "field_view_id_ms",
      formType: "input",
      label: "View ID (MS)",
      placeholder: "Enter View ID (MS)",
      // validation: { required: "View ID (MS) is required" },
    },
    {
      fieldName: "View ID (ZH)",
      fieldValue: "field_view_id_zh",
      className: "col-span-6",
      type: "text",
      name: "field_view_id_zh",
      formType: "input",
      label: "View ID (ZH)",
      placeholder: "Enter View ID (ZH)",
      // validation: { required: "View ID (ZH) is required" },
    },
    {
      fieldName: "Save (EN)",
      fieldValue: "field_save_en",
      className: "col-span-6",
      type: "text",
      name: "field_save_en",
      formType: "input",
      label: "Save (EN)",
      placeholder: "Enter Save (EN)",
      validation: { required: "Save (EN) is required" },
    },
    {
      fieldName: "Save (MS)",
      fieldValue: "field_save_ms",
      className: "col-span-6",
      type: "text",
      name: "field_save_ms",
      formType: "input",
      label: "Save (MS)",
      placeholder: "Enter Save (MS)",
      // validation: { required: "Save (MS) is required" },
    },
    {
      fieldName: "Save (ZH)",
      fieldValue: "field_save_zh",
      className: "col-span-6",
      type: "text",
      name: "field_save_zh",
      formType: "input",
      label: "Save (ZH)",
      placeholder: "Enter Save (ZH)",
      // validation: { required: "Save (ZH) is required" },
    },
    {
      fieldName: "Cancel (EN)",
      fieldValue: "field_cancel_en",
      className: "col-span-6",
      type: "text",
      name: "field_cancel_en",
      formType: "input",
      label: "Cancel (EN)",
      placeholder: "Enter Cancel (EN)",
      validation: { required: "Cancel (EN) is required" },
    },
    {
      fieldName: "Cancel (MS)",
      fieldValue: "field_cancel_ms",
      className: "col-span-6",
      type: "text",
      name: "field_cancel_ms",
      formType: "input",
      label: "Cancel (MS)",
      placeholder: "Enter Cancel (MS)",
      // validation: { required: "Cancel (MS) is required" },
    },
    {
      fieldName: "Cancel (ZH)",
      fieldValue: "field_cancel_zh",
      className: "col-span-6",
      type: "text",
      name: "field_cancel_zh",
      formType: "input",
      label: "Cancel (ZH)",
      placeholder: "Enter Cancel (ZH)",
      // validation: { required: "Cancel (ZH) is required" },
    },
    {
      fieldName: "Password Image",
      fieldValue: "field_pwd_image",
      className: "col-span-6",
      type: "image",
      name: "field_pwd_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Password Image",
      placeholder: "Upload Password Image",
      validation: { required: "Password Image is required" },
    },
    {
      fieldName: "Forward Image",
      fieldValue: "field_forward_image",
      className: "col-span-6",
      type: "image",
      name: "field_forward_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Forward Image",
      placeholder: "Upload Forward Image",
      validation: { required: "Forward Image is required" },
    },
    {
      fieldName: "Edit Profile Image",
      fieldValue: "field_edit_profile_image",
      className: "col-span-6",
      type: "image",
      name: "field_edit_profile_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Edit Profile Image",
      placeholder: "Upload Edit Profile Image",
      validation: { required: "Edit Profile Image is required" },
    },
    {
      fieldName: "Delete Icon Image",
      fieldValue: "field_delete_icon",
      className: "col-span-6",
      type: "image",
      name: "field_delete_icon",
      formType: "file",
      usedFileType: 'image/*',
      label: "Delete Icon Image",
      placeholder: "Upload Delete Icon Image",
      validation: { required: "Delete Icon Image is required" },
    },
  ],
  purchaseSuccess: [
    {
      fieldName: "Success Image",
      fieldValue: "field_success_image",
      className: "col-span-6",
      type: "image",
      name: "field_success_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Success Image",
      placeholder: "Enter Success Image",
      validation: { required: "Success Image is required" },
    },
    {
      fieldName: "Payment Approved (EN)",
      fieldValue: "field_payment_approved_en",
      className: "col-span-6",
      type: "text",
      name: "field_payment_approved_en",
      formType: "input",
      label: "Payment Approved (EN)",
      placeholder: "Enter Payment Approved (EN)",
      validation: { required: "Payment Approved (EN) is required" },
    },
    {
      fieldName: "Payment Approved (MS)",
      fieldValue: "field_payment_approved_ms",
      className: "col-span-6",
      type: "text",
      name: "field_payment_approved_ms",
      formType: "input",
      label: "Payment Approved (MS)",
      placeholder: "Enter Payment Approved (MS)",
      // validation: { required: "Payment Approved (MS) is required" },
    },
    {
      fieldName: "Payment Approved (ZH)",
      fieldValue: "field_payment_approved_zh",
      className: "col-span-6",
      type: "text",
      name: "field_payment_approved_zh",
      formType: "input",
      label: "Payment Approved (ZH)",
      placeholder: "Enter Payment Approved (ZH)",
      // validation: { required: "Payment Approved (ZH) is required" },
    },
    {
      fieldName: "Login Id Success (EN)",
      fieldValue: "field_login_id_success_en",
      className: "col-span-6",
      type: "text",
      name: "field_login_id_success_en",
      formType: "input",
      label: "Login Id Success (EN)",
      placeholder: "Enter Login Id Success (EN)",
      validation: { required: "Login Id Success (EN) is required" },
    },
    {
      fieldName: "Login Id Success (MS)",
      fieldValue: "field_login_id_success_ms",
      className: "col-span-6",
      type: "text",
      name: "field_login_id_success_ms",
      formType: "input",
      label: "Login Id Success (MS)",
      placeholder: "Enter Login Id Success (MS)",
      // validation: { required: "Login Id Success (MS) is required" },
    },
    {
      fieldName: "Login Id Success (ZH)",
      fieldValue: "field_login_id_success_zh",
      className: "col-span-6",
      type: "text",
      name: "field_login_id_success_zh",
      formType: "input",
      label: "Login Id Success (ZH)",
      placeholder: "Enter Login Id Success (ZH)",
      // validation: { required: "Login Id Success (ZH) is required" },
    },
    {
      fieldName: "ID Status (EN)",
      fieldValue: "field_id_status_en",
      className: "col-span-6",
      type: "text",
      name: "field_id_status_en",
      formType: "input",
      label: "ID Status (EN)",
      placeholder: "Enter ID Status (EN)",
      validation: { required: "ID Status (EN) is required" },
    },
    {
      fieldName: "ID Status (MS)",
      fieldValue: "field_id_status_ms",
      className: "col-span-6",
      type: "text",
      name: "field_id_status_ms",
      formType: "input",
      label: "ID Status (MS)",
      placeholder: "Enter ID Status (MS)",
      // validation: { required: "ID Status (MS) is required" },
    },
    {
      fieldName: "ID Status (ZH)",
      fieldValue: "field_id_status_zh",
      className: "col-span-6",
      type: "text",
      name: "field_id_status_zh",
      formType: "input",
      label: "ID Status (ZH)",
      placeholder: "Enter ID Status (ZH)",
      // validation: { required: "ID Status (ZH) is required" },
    },
    {
      fieldName: "User ID (EN)",
      fieldValue: "field_user_id_en",
      className: "col-span-6",
      type: "text",
      name: "field_user_id_en",
      formType: "input",
      label: "User ID (EN)",
      placeholder: "Enter User ID (EN)",
      validation: { required: "User ID (EN) is required" },
    },
    {
      fieldName: "User ID (MS)",
      fieldValue: "field_user_id_ms",
      className: "col-span-6",
      type: "text",
      name: "field_user_id_ms",
      formType: "input",
      label: "User ID (MS)",
      placeholder: "Enter User ID (MS)",
      // validation: { required: "User ID (MS) is required" },
    },
    {
      fieldName: "User ID (ZH)",
      fieldValue: "field_user_id_zh",
      className: "col-span-6",
      type: "text",
      name: "field_user_id_zh",
      formType: "input",
      label: "User ID (ZH)",
      placeholder: "Enter User ID (ZH)",
      // validation: { required: "User ID (ZH) is required" },
    },
    {
      fieldName: "Password (EN)",
      fieldValue: "field_pwd_en",
      className: "col-span-6",
      type: "text",
      name: "field_pwd_en",
      formType: "input",
      label: "Password (EN)",
      placeholder: "Enter Password (EN)",
      validation: { required: "Password (EN) is required" },
    },
    {
      fieldName: "Password (MS)",
      fieldValue: "field_pwd_ms",
      className: "col-span-6",
      type: "text",
      name: "field_pwd_ms",
      formType: "input",
      label: "Password (MS)",
      placeholder: "Enter Password (MS)",
      // validation: { required: "Password (MS) is required" },
    },
    {
      fieldName: "Password (ZH)",
      fieldValue: "field_pwd_zh",
      className: "col-span-6",
      type: "text",
      name: "field_pwd_zh",
      formType: "input",
      label: "Password (ZH)",
      placeholder: "Enter Password (ZH)",
      // validation: { required: "Password (ZH) is required" },
    },
    {
      fieldName: "Support (EN)",
      fieldValue: "field_support_en",
      className: "col-span-6",
      type: "text",
      name: "field_support_en",
      formType: "input",
      label: "Support (EN)",
      placeholder: "Enter Support (EN)",
      validation: { required: "Support (EN) is required" },
    },
    {
      fieldName: "Support (MS)",
      fieldValue: "field_support_ms",
      className: "col-span-6",
      type: "text",
      name: "field_support_ms",
      formType: "input",
      label: "Support (MS)",
      placeholder: "Enter Support (MS)",
      // validation: { required: "Support (MS) is required" },
    },
    {
      fieldName: "Support (ZH)",
      fieldValue: "field_support_zh",
      className: "col-span-6",
      type: "text",
      name: "field_support_zh",
      formType: "input",
      label: "Support (ZH)",
      placeholder: "Enter Support (ZH)",
      // validation: { required: "Support (ZH) is required" },
    },
    {
      fieldName: "Support Email (EN)",
      fieldValue: "field_support_email",
      className: "col-span-6",
      type: "text",
      name: "field_support_email",
      formType: "input",
      label: "Support Email (EN)",
      placeholder: "Enter Support Email (EN)",
      validation: { required: "Support Email (EN) is required" },
    },
    {
      fieldName: "Support Email (MS)",
      fieldValue: "field_support_email_ms",
      className: "col-span-6",
      type: "text",
      name: "field_support_email_ms",
      formType: "input",
      label: "Support Email (MS)",
      placeholder: "Enter Support Email (MS)",
      // validation: { required: "Support Email (MS) is required" },
    },
    {
      fieldName: "Support Email (ZH)",
      fieldValue: "field_support_email_zh",
      className: "col-span-6",
      type: "text",
      name: "field_support_email_zh",
      formType: "input",
      label: "Support Email (ZH)",
      placeholder: "Enter Support Email (ZH)",
      // validation: { required: "Support Email (ZH) is required" },
    },
    {
      fieldName: "Business Hours (EN)",
      fieldValue: "field_bhrs_en",
      className: "col-span-6",
      type: "text",
      name: "field_bhrs_en",
      formType: "input",
      label: "Business Hours (EN)",
      placeholder: "Enter Business Hours (EN)",
      validation: { required: "Business Hours (EN) is required" },
    },
    {
      fieldName: "Business Hours (MS)",
      fieldValue: "field_bhrs_ms",
      className: "col-span-6",
      type: "text",
      name: "field_bhrs_ms",
      formType: "input",
      label: "Business Hours (MS)",
      placeholder: "Enter Business Hours (MS)",
      // validation: { required: "Business Hours (MS) is required" },
    },
    {
      fieldName: "Business Hours (ZH)",
      fieldValue: "field_bhrs_zh",
      className: "col-span-6",
      type: "text",
      name: "field_bhrs_zh",
      formType: "input",
      label: "Business Hours (ZH)",
      placeholder: "Enter Business Hours (ZH)",
      // validation: { required: "Business Hours (ZH) is required" },
    },
    {
      fieldName: "Ok (EN)",
      fieldValue: "field_ok_en",
      className: "col-span-6",
      type: "text",
      name: "field_ok_en",
      formType: "input",
      label: "Ok (EN)",
      placeholder: "Enter Ok (EN)",
      validation: { required: "Ok (EN) is required" },
    },
    {
      fieldName: "Ok (MS)",
      fieldValue: "field_ok_ms",
      className: "col-span-6",
      type: "text",
      name: "field_ok_ms",
      formType: "input",
      label: "Ok (MS)",
      placeholder: "Enter Ok (MS)",
      // validation: { required: "Ok (MS) is required" },
    },
    {
      fieldName: "Ok (ZH)",
      fieldValue: "field_ok_zh",
      className: "col-span-6",
      type: "text",
      name: "field_ok_zh",
      formType: "input",
      label: "Ok (ZH)",
      placeholder: "Enter Ok (ZH)",
      // validation: { required: "Ok (ZH) is required" },
    },
    {
      fieldName: "Approve (EN)",
      fieldValue: "field_approve_en",
      className: "col-span-6",
      type: "text",
      name: "field_approve_en",
      formType: "input",
      label: "Approve (EN)",
      placeholder: "Enter Approve (EN)",
      validation: { required: "Approve (EN) is required" },
    },
    {
      fieldName: "Approve (MS)",
      fieldValue: "field_approve_ms",
      className: "col-span-6",
      type: "text",
      name: "field_approve_ms",
      formType: "input",
      label: "Approve (MS)",
      placeholder: "Enter Approve (MS)",
      // validation: { required: "Approve (MS) is required" },
    },
    {
      fieldName: "Approve (ZH)",
      fieldValue: "field_approve_zh",
      className: "col-span-6",
      type: "text",
      name: "field_approve_zh",
      formType: "input",
      label: "Approve (ZH)",
      placeholder: "Enter Approve (ZH)",
      // validation: { required: "Approve (ZH) is required" },
    },
  ],
  purchaseQR: [
    {
      fieldName: "Title",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title",
      placeholder: "Enter Title",
      validation: { required: "Title is required" },
    },
    {
      fieldName: "Login Purchase (EN)",
      fieldValue: "field_login_id_purchase",
      className: "col-span-6",
      type: "text",
      name: "field_login_id_purchase",
      formType: "input",
      label: "Login Purchase (EN)",
      placeholder: "Enter Login ID Purchase (EN)",
      validation: { required: "Login ID Purchase (EN) is required" },
    },
    {
      fieldName: "Login Purchase (MS)",
      fieldValue: "field_login_purchase_ms",
      className: "col-span-6",
      type: "text",
      name: "field_login_purchase_ms",
      formType: "input",
      label: "Login Purchase (MS)",
      placeholder: "Enter Login Purchase (MS)",
      // validation: { required: "Login Purchase (MS) is required" },
    },
    {
      fieldName: "Login Purchase (ZH)",
      fieldValue: "field_login_purchase_zh",
      className: "col-span-6",
      type: "text",
      name: "field_login_purchase_zh",
      formType: "input",
      label: "Login Purchase (ZH)",
      placeholder: "Enter Login Purchase (ZH)",
      // validation: { required: "Login Purchase (ZH) is required" },
    },
    {
      fieldName: "Payment Text (EN)",
      fieldValue: "field_payment_txt_en",
      className: "col-span-6",
      type: "text",
      name: "field_payment_txt_en",
      formType: "input",
      label: "Payment Text (EN)",
      placeholder: "Enter Payment Text (EN)",
      validation: { required: "Payment Text (EN) is required" },
    },
    {
      fieldName: "Payment Text (MS)",
      fieldValue: "field_payment_txt_ms",
      className: "col-span-6",
      type: "text",
      name: "field_payment_txt_ms",
      formType: "input",
      label: "Payment Text (MS)",
      placeholder: "Enter Payment Text (MS)",
      // validation: { required: "Payment Text (MS) is required" },
    },
    {
      fieldName: "Payment Text (ZH)",
      fieldValue: "field_payment_txt_zh",
      className: "col-span-6",
      type: "text",
      name: "field_payment_txt_zh",
      formType: "input",
      label: "Payment Text (ZH)",
      placeholder: "Enter Payment Text (ZH)",
      // validation: { required: "Payment Text (ZH) is required" },
    },
    {
      fieldName: "Confirm Text (EN)",
      fieldValue: "field_confirm_txt_en",
      className: "col-span-6",
      type: "text",
      name: "field_confirm_txt_en",
      formType: "input",
      label: "Confirm Text (EN)",
      placeholder: "Enter Confirm Text (EN)",
      validation: { required: "Confirm Text (EN) is required" },
    },
    {
      fieldName: "Confirm Text (MS)",
      fieldValue: "field_confirm_txt_ms",
      className: "col-span-6",
      type: "text",
      name: "field_confirm_txt_ms",
      formType: "input",
      label: "Confirm Text (MS)",
      placeholder: "Enter Confirm Text (MS)",
      // validation: { required: "Confirm Text (MS) is required" },
    },
    {
      fieldName: "Confirm Text (ZH)",
      fieldValue: "field_confirm_txt_zh",
      className: "col-span-6",
      type: "text",
      name: "field_confirm_txt_zh",
      formType: "input",
      label: "Confirm Text (ZH)",
      placeholder: "Enter Confirm Text (ZH)",
      // validation: { required: "Confirm Text (ZH) is required" },
    },
    {
      fieldName: "Account Details (EN)",
      fieldValue: "field_account_details_en",
      className: "col-span-6",
      type: "text",
      name: "field_account_details_en",
      formType: "input",
      label: "Account Details (EN)",
      placeholder: "Enter Account Details (EN)",
      validation: { required: "Account Details (EN) is required" },
    },
    {
      fieldName: "Account Details (MS)",
      fieldValue: "field_account_details_ms",
      className: "col-span-6",
      type: "text",
      name: "field_account_details_ms",
      formType: "input",
      label: "Account Details (MS)",
      placeholder: "Enter Account Details (MS)",
      // validation: { required: "Account Details (MS) is required" },
    },
    {
      fieldName: "Account Details (ZH)",
      fieldValue: "field_account_details_zh",
      className: "col-span-6",
      type: "text",
      name: "field_account_details_zh",
      formType: "input",
      label: "Account Details (ZH)",
      placeholder: "Enter Account Details (ZH)",
      // validation: { required: "Account Details (ZH) is required" },
    },
    {
      fieldName: "Bank Name (EN)",
      fieldValue: "field_bank_name_en",
      className: "col-span-6",
      type: "text",
      name: "field_bank_name_en",
      formType: "input",
      label: "Bank Name (EN)",
      placeholder: "Enter Bank Name (EN)",
      validation: { required: "Bank Name (EN) is required" },
    },
    {
      fieldName: "Bank Name (MS)",
      fieldValue: "field_bank_name_ms",
      className: "col-span-6",
      type: "text",
      name: "field_bank_name_ms",
      formType: "input",
      label: "Bank Name (MS)",
      placeholder: "Enter Bank Name (MS)",
      // validation: { required: "Bank Name (MS) is required" },
    },
    {
      fieldName: "Bank Name (ZH)",
      fieldValue: "field_bank_name_zh",
      className: "col-span-6",
      type: "text",
      name: "field_bank_name_zh",
      formType: "input",
      label: "Bank Name (ZH)",
      placeholder: "Enter Bank Name (ZH)",
      // validation: { required: "Bank Name (ZH) is required" },
    },
    {
      fieldName: "Account NO (EN)",
      fieldValue: "field_account_no_en",
      className: "col-span-6",
      type: "text",
      name: "field_account_no_en",
      formType: "input",
      label: "Account NO (EN)",
      placeholder: "Enter Account NO (EN)",
      validation: { required: "Account NO (EN) is required" },
    },
    {
      fieldName: "Account NO (MS)",
      fieldValue: "field_account_no_ms",
      className: "col-span-6",
      type: "text",
      name: "field_account_no_ms",
      formType: "input",
      label: "Account NO (MS)",
      placeholder: "Enter Account NO (MS)",
      // validation: { required: "Account NO (MS) is required" },
    },
    {
      fieldName: "Account NO (ZH)",
      fieldValue: "field_account_no_zh",
      className: "col-span-6",
      type: "text",
      name: "field_account_no_zh",
      formType: "input",
      label: "Account NO (ZH)",
      placeholder: "Enter Account NO (ZH)",
      // validation: { required: "Account NO (ZH) is required" },
    },
    {
      fieldName: "Name (EN)",
      fieldValue: "field_name_en",
      className: "col-span-6",
      type: "text",
      name: "field_name_en",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "field_name_ms",
      className: "col-span-6",
      type: "text",
      name: "field_name_ms",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Name (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "field_name_zh",
      className: "col-span-6",
      type: "text",
      name: "field_name_zh",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter Name (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
    {
      fieldName: "Total Pay Amount (EN)",
      fieldValue: "field_total_pay_amt_en",
      className: "col-span-6",
      type: "text",
      name: "field_total_pay_amt_en",
      formType: "input",
      label: "Total Pay Amount (EN)",
      placeholder: "Enter Total Pay Amount (EN)",
      validation: { required: "Total Pay Amount (EN) is required" },
    },
    {
      fieldName: "Total Pay Amount (MS)",
      fieldValue: "field_total_pay_amt_ms",
      className: "col-span-6",
      type: "text",
      name: "field_total_pay_amt_ms",
      formType: "input",
      label: "Total Pay Amount (MS)",
      placeholder: "Enter Total Pay Amount (MS)",
      // validation: { required: "Total Pay Amount (MS) is required" },
    },
    {
      fieldName: "Total Pay Amount (ZH)",
      fieldValue: "field_total_pay_amt_zh",
      className: "col-span-6",
      type: "text",
      name: "field_total_pay_amt_zh",
      formType: "input",
      label: "Total Pay Amount (ZH)",
      placeholder: "Enter Total Pay Amount (ZH)",
      // validation: { required: "Total Pay Amount (ZH) is required" },
    },
    {
      fieldName: "Scan Text (EN)",
      fieldValue: "field_scan_txt_en",
      className: "col-span-6",
      type: "text",
      name: "field_scan_txt_en",
      formType: "input",
      label: "Scan Text (EN)",
      placeholder: "Enter Scan Text (EN)",
      validation: { required: "Scan Text (EN) is required" },
    },
    {
      fieldName: "Scan Text (MS)",
      fieldValue: "field_scan_txt_ms",
      className: "col-span-6",
      type: "text",
      name: "field_scan_txt_ms",
      formType: "input",
      label: "Scan Text (MS)",
      placeholder: "Enter Scan Text (MS)",
      // validation: { required: "Scan Text (MS) is required" },
    },
    {
      fieldName: "Scan Text (ZH)",
      fieldValue: "field_scan_txt_zh",
      className: "col-span-6",
      type: "text",
      name: "field_scan_txt_zh",
      formType: "input",
      label: "Scan Text (ZH)",
      placeholder: "Enter Scan Text (ZH)",
      // validation: { required: "Scan Text (ZH) is required" },
    },
    {
      fieldName: "Upload Text (EN)",
      fieldValue: "field_upload_txt_en",
      className: "col-span-6",
      type: "text",
      name: "field_upload_txt_en",
      formType: "input",
      label: "Upload Text (EN)",
      placeholder: "Enter Upload Text (EN)",
      validation: { required: "Upload Text (EN) is required" },
    },
    {
      fieldName: "Upload Text (MS)",
      fieldValue: "field_upload_txt_ms",
      className: "col-span-6",
      type: "text",
      name: "field_upload_txt_ms",
      formType: "input",
      label: "Upload Text (MS)",
      placeholder: "Enter Upload Text (MS)",
      // validation: { required: "Upload Text (MS) is required" },
    },
    {
      fieldName: "Upload Text (ZH)",
      fieldValue: "field_upload_txt_zh",
      className: "col-span-6",
      type: "text",
      name: "field_upload_txt_zh",
      formType: "input",
      label: "Upload Text (ZH)",
      placeholder: "Enter Upload Text (ZH)",
      // validation: { required: "Upload Text (ZH) is required" },
    },
    {
      fieldName: "Choose (EN)",
      fieldValue: "field_choose_en",
      className: "col-span-6",
      type: "text",
      name: "field_choose_en",
      formType: "input",
      label: "Choose (EN)",
      placeholder: "Enter Choose (EN)",
      validation: { required: "Choose (EN) is required" },
    },
    {
      fieldName: "Choose (MS)",
      fieldValue: "field_choose_ms",
      className: "col-span-6",
      type: "text",
      name: "field_choose_ms",
      formType: "input",
      label: "Choose (MS)",
      placeholder: "Enter Choose (MS)",
      // validation: { required: "Choose (MS) is required" },
    },
    {
      fieldName: "Choose (ZH)",
      fieldValue: "field_choose_zh",
      className: "col-span-6",
      type: "text",
      name: "field_choose_zh",
      formType: "input",
      label: "Choose (ZH)",
      placeholder: "Enter Choose (ZH)",
      // validation: { required: "Choose (ZH) is required" },
    },
    {
      fieldName: "Format (EN)",
      fieldValue: "field_format_en",
      className: "col-span-6",
      type: "text",
      name: "field_format_en",
      formType: "input",
      label: "Format (EN)",
      placeholder: "Enter Format (EN)",
      validation: { required: "Format (EN) is required" },
    },
    {
      fieldName: "Format (MS)",
      fieldValue: "field_format_ms",
      className: "col-span-6",
      type: "text",
      name: "field_format_ms",
      formType: "input",
      label: "Format (MS)",
      placeholder: "Enter Format (MS)",
      // validation: { required: "Format (MS) is required" },
    },
    {
      fieldName: "Format (ZH)",
      fieldValue: "field_format_zh",
      className: "col-span-6",
      type: "text",
      name: "field_format_zh",
      formType: "input",
      label: "Format (ZH)",
      placeholder: "Enter Format (ZH)",
      // validation: { required: "Format (ZH) is required" },
    },
  ],
};
